<template>
  <div>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex class="sidebar-slot">
        <AppSidebar :items="items" v-model="sideNav" />
      </v-flex>
      <v-flex class="main-content-flex">
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" @toggle-nav="sideNav = !sideNav" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center style="background-color: #f6fff9">
              <v-flex xs12>
                <v-card min-height="100vh" color="#FFFFFF" flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AppHeader from "@/components/Common/appHeadersarpa";
import AppSidebar from "@/components/Common/appSidebar";

export default {
  name: "DisasterManagementOfficerLayout",
  components: {
    AppHeader,
    AppSidebar,
  },
  data() {
    return {
      //open state for the sidebar; only used below md, where it overlays
      sideNav: false,
      items: [
        {
          title: "Response Dashboard",
          icon: "mdi-chart-timeline-variant",
          path: "/disaster/districtDashboard",
        },
        {
          title: "Snake Bite Alerts",
          icon: "mdi-bell-alert",
          path: "/disaster/snakebiteAlerts",
        },
        {
          title: "Rescuer List",
          icon: "mdi-account-multiple-plus",
          path: "/disaster/allrescuerlistDis",
        },
        {
          title: "DMO List",
          icon: "mdi-doctor",
          path: "/disaster/dmoListDis",
        },
        // {
        //   title: "Snake Bite Cases",
        //   icon: "mdi-hospital-box-outline",
        //   path: "/disaster/snakeBiteDis",
        // },
        {
          title: "Activity Log",
          icon: "mdi-history",
          path: "/disaster/activityLog",
        },
        {
          title: "Anti-Venom Stock",
          icon: "mdi-medical-bag",
          path: "/disaster/stockVenom",
        },
      ],
      right: null,
    };
  },
};
</script>

<style scoped>
/* reserves the column the fixed sidebar occupies from md up */
.sidebar-slot {
  flex: 0 0 0 !important;
  max-width: 0 !important;
  width: 0 !important;
}
@media (min-width: 960px) {
  .sidebar-slot {
    flex: 0 0 280px !important;
    max-width: 280px !important;
    width: 280px !important;
  }
}

.main-content-flex {
  flex: 1 1 auto !important;
  max-width: 100% !important;
  width: 100% !important;
}

@media (min-width: 960px) {
  .main-content-flex {
    max-width: calc(100% - 280px) !important;
    width: calc(100% - 280px) !important;
  }
}
</style>
